import {
  ACCOUNTS_FILTER_TYPE,
  RECEIVABLE,
  STATUS_OPENED,
  STATUS_DOWNLOADED,
  STATUS_PARTIAL_DOWNLOADED,
  STATUS_CANCELED,
  IUGU_ACTION_RECREATE,
  IUGU_ACTION_ADD,
} from '../utils/constants';
import { addQuotes, getArrayStringify } from '../utils/smartutils';

export function accountList() {
  const query = `{
    accountListByFilter(
      filter: {
        filterByStatus: true
        active: false
        updaterId: 0
        checkingAccount: false
        id: 0
        integrateIfIugu: false
        smartpay: false
        defaultAccount: false
        extraWithdrawalAmount: 0
        numberWithdrawals: 0
      }
    ) {
      id
      name
      filterByStatus
      updaterId
      checkingAccount
      active
      defaultAccount
      integrateIfIugu
      smartpay
      numberWithdrawals 
      extraWithdrawalAmount
      iuguAccountInfo {
        verificationStatus
        interestForDelay
        dailyInterestForDelay
        interestRateForDelay
        autoWithDraw 
        balanceAvailableForWithdraw 
        accountId 
        bankSlipCommission 
        useBankSlip
      }
    }
  }  
`;
  return query;
}

export function categoryList() {
  const query = `{
	receivingCategoryListByFilter(
		filter: { filterByStatus: true, updaterId: 0, active: true, id: 0 }
	) {
		id
		name
    value
    label
	}
}
`;
  return query;
}

export function studentListByFilter(filter) {
  let classesId;
  let responsiblesId;
  let menusId;

  if (filter.classes) {
    classesId = filter.classes.map((classes) => classes.id);
  }

  if (filter.responsibles) {
    responsiblesId = filter.responsibles.map((responsibles) => responsibles.id);
  }

  if (filter.menus) {
    menusId = filter.menus.map((menus) => menus.id);
  }

  const query = `{studentListByFilter(filter:{id:0, classes:[${
    classesId || []
  }],responsibles:[${responsiblesId || []}],menus:[${
    menusId || []
  }], onlyActive:${filter.onlyActive || true}}){
    id
		fullName
		classesNames
    updaterId
    active
    legacyId
    dateOfBirth
    activeOnLoggedPeriod
  }
}`;

  return query;
}

export function responsibleFinancialContactByStudent(studentId) {
  const query = `{
	responsibleFinancialContactByStudent(studentId: ${studentId}) {
		id
		fullName
    cpf
    zipCode
    address
    addressNumber
    email
    filterByStatus
    updaterId
    validateCpfOnSubmit
    neighborhood
  }
}`;
  return query;
}

export function responsibleList() {
  const query = `{
	responsibleListAll(displayOnlyActives: false) {
		id
		fullName
    value
    label
	}
}
`;
  return query;
}

export function contractList(status) {
  const query = `{
    contractListByFilter(
      filter: { status: ${
        status ? `"${status}"` : null
      }, initialDate: 0, finalDate: 0, id: 0 }
    ) {
      id
      numberContract
      value
      label
    }
  }`;
  return query;
}

export function paymentFrequencyListByFilter() {
  const query = `{
    paymentFrequencyListByFilter(filter: { filterByActive: true, active: true }) {
      id
      name
      monthlyFrequency
      daylyFrequency
      active
      order
      type
    }
  }
  
  `;
  return query;
}

function getAccountFilter(values) {
  const {
    downloaded,
    canceled,
    opened,
    partiallyDownloaded,
    type,
    initialDate,
    finalDate,
    contract,
    categoryId,
    clientId,
    dateFilterType,
    accountId,
  } = values;

  let filterByContract = false;
  const status = [];
  if (opened) {
    status.push(STATUS_OPENED);
  }
  if (downloaded) {
    status.push(STATUS_DOWNLOADED);
  }
  if (canceled) {
    status.push(STATUS_CANCELED);
  }
  if (partiallyDownloaded) {
    status.push(STATUS_PARTIAL_DOWNLOADED);
  }
  if (contract && contract.id) {
    filterByContract = true;
  }
  return {
    type:
      type === RECEIVABLE
        ? ACCOUNTS_FILTER_TYPE.RECEIVABLE
        : ACCOUNTS_FILTER_TYPE.PAYABLE,
    dateFilterType,
    initialDate: initialDate.getTime(),
    finalDate: finalDate.getTime(),
    filterByContract,
    contractId: contract && contract.id ? contract.id : 0,
    onlySmartPayInvoices: false,
    status,
    categoryId: categoryId.id || 0,
    clientId: clientId.id || 0,
    accountId: accountId && accountId.id ? accountId.id : 0,
  };
}

export function financialListByFilter(values) {
  const filter = getAccountFilter(values);
  const query = `{
	financialListByFilter(
		filter: ${JSON.stringify(filter).replace(/"([^(")"]+)":/g, '$1:')}
	) {
    receivedAmount
    amountToReceive
    owedAmount
    numberOfRecords
    receivedAmountInFormat
    amountToReceiveInFormat
    owedAmountInFormat
    invoices{
      id
      description
      contract
      category {
        name
      }
      account {
        name
        smartpay
      }
      quota
      dueDate
      value
      amountReceived
      discount
      student {
        fullName
      }
      responsible {
        fullName
        cpf
      }
      status
      ticketUrl
      payment {
        payDay
      }
      formattedDueDate
      cpf
      formattedPaymentDate
      formattedValue
      formattedAmountReceived
      formattedDiscount
      status
      statusDescription
    }
  }
}
`;
  return query;
}

export function financialById(id) {
  const query = `{
    financialById(id: ${id}) {
      id
      description
      obs
      contractId
      account {
        id
        name
        smartpay
        numberWithdrawals 
        extraWithdrawalAmount
        filterByStatus
        updaterId
        checkingAccount
        active
        defaultAccount
        integrateIfIugu
        iuguAccountInfo {
          verificationStatus
          autoWithDraw 
          balanceAvailableForWithdraw 
          accountId 
          dailyInterestForDelay 
          bankSlipCommission 
          interestRateForDelay 
          interestForDelay 
          useBankSlip
        }
      }
      contract
      category {
        id
        name
      }
      quota
      dueDate
      value
      amountReceived
      discount
      student {
        id
        fullName
        updaterId
        active
        legacyId
        dateOfBirth
        activeOnLoggedPeriod
      }
      responsible {
        id
        fullName
        cpf
        zipCode
        address
        addressNumber
        neighborhood
        email
        filterByStatus
        updaterId
        validateCpfOnSubmit
      }
      status
      ticketUrl
      competencyDate
      fines
      latePaymentFine
      perDayInterest
      applyDiscountConfiguration
      inTestEnvironment
      automaticBilling
      docTitu
    }
  }
  `;
  return query;
}

export function discountConfigurationByTitle(id) {
  const query = `{
    discountConfigurationByTitle(titleId: ${id}) {
      id
      titleId
      daysBeforeExpiration
      discountPercentage
    }
  }`;
  return query;
}

export function financialSaveMutation(values) {
  let iuguAction = IUGU_ACTION_ADD;
  if (
    values.updateCategory ||
    values.updateDescription ||
    values.updateObservation ||
    values.updateValue ||
    values.updateCompetence ||
    values.updateDueDate ||
    values.updateDiscount
  ) {
    iuguAction = IUGU_ACTION_RECREATE;
  }

  const category = {
    id: values.category.id,
    name: values.category.name,
    filterByStatus: false,
    updaterId: 0,
    active: true,
  };

  const student = {
    id: values.student.id,
    filterByStatus: false,
    updaterId: values.student.updaterId,
    active: values.student.active,
    legacyId: values.student.legacyId,
    dateOfBirth: values.student.dateOfBirth,
    activeOnLoggedPeriod: values.student.activeOnLoggedPeriod,
  };

  const responsible = {
    id: values.responsible.id,
    fullName: values.responsible.fullName,
    cpf: values.responsible.cpf,
    zipCode: values.responsible.zipCode,
    address: values.responsible.address,
    addressNumber: values.responsible.addressNumber,
    neighborhood: values.responsible.neighborhood,
    email: values.responsible.email,
    filterByStatus: values.responsible.filterByStatus,
    updaterId: values.responsible.updaterId,
    validateCpfOnSubmit: values.responsible.validateCpfOnSubmit,
    chatUserId: values.responsible.chatUserId
      ? values.responsible.chatUserId
      : 0,
  };

  let iuguAccountInfo = null;
  if (values.account.smartpay && values.account.iuguAccountInfo) {
    iuguAccountInfo = {
      verificationStatus: values.account.iuguAccountInfo.verificationStatus,
      autoWithDraw: values.account.iuguAccountInfo.autoWithDraw,
      balanceAvailableForWithdraw:
        values.account.iuguAccountInfo.balanceAvailableForWithdraw,
      accountId: values.account.iuguAccountInfo.accountId,
      dailyInterestForDelay:
        values.account.iuguAccountInfo.dailyInterestForDelay,
      bankSlipCommission: values.account.iuguAccountInfo.bankSlipCommission,
      interestRateForDelay: values.account.iuguAccountInfo.interestRateForDelay,
      interestForDelay: values.account.iuguAccountInfo.interestForDelay,
      useBankSlip: values.account.iuguAccountInfo.useBankSlip,
    };
  }

  const account = {
    id: values.account.id,
    filterByStatus: values.account.filterByStatus,
    updaterId: values.account.updaterId,
    checkingAccount: values.account.checkingAccount,
    active: values.account.active,
    defaultAccount: values.account.defaultAccount,
    integrateIfIugu: values.account.integrateIfIugu,
    smartpay: values.account.smartpay,
    iuguAccountInfo,
    numberWithdrawals: values.account.numberWithdrawals,
    extraWithdrawalAmount: values.account.extraWithdrawalAmount,
  };

  let discountConfigurations;
  if (values.applyDiscountConfiguration) {
    discountConfigurations = values.discountConfigurations.map((item) => {
      if (item.tableData) {
        const { tableData, ...itemRef } = item;
        return itemRef;
      }
      return item;
    });
  } else {
    discountConfigurations = [];
  }

  let paymentFrequency;
  if (values.indRepeat) {
    paymentFrequency = {
      id: values.paymentFrequency.id,
      monthlyFrequency: values.paymentFrequency.monthlyFrequency,
      daylyFrequency: values.paymentFrequency.daylyFrequency,
      active: values.paymentFrequency.active,
      order: values.paymentFrequency.order,
      type: values.paymentFrequency.type,
    };
  } else {
    paymentFrequency = {
      id: 0,
      monthlyFrequency: 0,
      daylyFrequency: 0,
      active: false,
      order: 0,
    };
  }
  const mutationQuery = `mutation ($description: String!, $obs: String){
    financialSave(
      financial: {
        id: ${values.id ? values.id : 0} 
        description: $description
        contractId: ${values.contractId ? values.contractId : 0}
        contract: ""
        category: ${JSON.stringify(category).replace(/"([^(")"]+)":/g, '$1:')}
        quota: "${values.quota || ''}"
        value: ${values.value}
        amountReceived: 0
        discount: 0
        student: ${JSON.stringify(student).replace(/"([^(")"]+)":/g, '$1:')}
        responsible: ${JSON.stringify(responsible).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )}
        statusDescription: ""
        obs: $obs
        account: ${JSON.stringify(account).replace(/"([^(")"]+)":/g, '$1:')}
        dueDate: ${values.dueDate.getTime()}
        issuanceDate: ${new Date().getTime()}
        competencyDate: ${values.competencyDate.getTime()}
        fines: ${values.fines || false}
        latePaymentFine: ${values.latePaymentFine || 0}
        perDayInterest: ${values.perDayInterest || false}
        applyDiscountConfiguration: ${
          values.applyDiscountConfiguration || false
        }
        discountConfigurations: ${JSON.stringify(
          discountConfigurations
        ).replace(/"([^(")"]+)":/g, '$1:')}
        iuguAction: "${iuguAction}"
        operation: "R"
        type: "R"
        status: "${values.status || STATUS_OPENED}"
        automaticBilling: ${values.automaticBilling || false}
        products: []
        indRepeat: ${values.indRepeat || false}
        parcTitu: ${values.parcTitu || 1}
        nupaTitu: ${values.nupaTitu || 1}
        paymentFrequency: ${JSON.stringify(paymentFrequency).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )}
        inTestEnvironment: ${values.inTestEnvironment || false}
        ticketUrl: "${values.ticketUrl || ''}"
        updateOption: "U"
        updateCategory: ${values.updateCategory || false}
        updateDescription: ${values.updateDescription || false}
        updateObservation: ${values.updateObservation || false}
        updateAccount: false
        updateValue: ${values.updateValue || false}
        updateCompetence: ${values.updateCompetence || false}
        updateDueDate: ${values.updateDueDate || false}
        updateDiscount: ${values.updateDiscount || false}
        updateAutomaticBilling: false
        docTitu: ${values.docTitu ? addQuotes(values.docTitu) : null},
      }
    ) {
      id
    }
  }
  `;
  return mutationQuery;
}

export function paymentSaveMutation(values) {
  const mutation = `mutation {
    paymentSave(
      payment: {
        id: 0
        idTitle: ${values.id}
        obs: "${
          values.obs ||
          'Baixa realizada automaticamente, mediante cancelamento de título.'
        }"
        payDay: ${
          values.payDay ? values.payDay.getTime() : new Date().getTime()
        }
        discount: ${values.discount || 0}
        additions: ${values.additions || 0}
        amountPayment: ${values.value}
      }
    ) {
      id
      statusTitle
    }
  }
  `;
  return mutation;
}

export function paymentByTitle(id) {
  const query = `{
    paymentByTitle(titleId: ${id}) {
      id
      obs
      payDay
      discount
      additions
      amountPayment
    }
  }
  `;
  return query;
}

export function financialItensByTitle(id) {
  const query = `{
    financialItensByTitle(titleId: ${id}) {
      id
      category {
        id
        name
      }
      value
      quota
    }
  }
  
  `;
  return query;
}

export function removePaymentByTitle(values) {
  const query = `mutation {
    paymentDelet(
      payment: {
        id: ${values.id}
        idTitle: ${values.id}
        additions: ${values.additions}
        amountPayment: ${values.amountPayment}
        discount: ${values.discount}
        payDay: ${values.payDay}
      }
    )
  }  
  `;
  return query;
}

export function discountConfigurationByAccount(account) {
  const query = `{
    discountConfigurationByAccount(accountId: ${account}) {
      id
      daysBeforeExpiration
      discountPercentage
    }
  }
  `;
  return query;
}

export function financialCancelMutation(values) {
  const query = `mutation {
    financialCancel(idTitle: ${values.id}, type: "${values.type}") {
      id
    }
  }
  `;
  return query;
}

export function financialCancelByInvoicesId(ids, type) {
  return `mutation {
    financialCancelByInvoicesId(ids: ${getArrayStringify(
      ids
    )}, type: ${addQuotes(type)}) { id }
  }
  `;
}
